import { render } from "./Participants.vue?vue&type=template&id=b991f382&bindings={\"modals\":\"setup\",\"active\":\"setup\",\"players\":\"setup\",\"filteredPlayers\":\"setup\",\"playersDuel\":\"setup\",\"playersDraft\":\"setup\",\"limitDuel\":\"setup\",\"limitDraft\":\"setup\",\"staff\":\"setup\",\"spectators\":\"setup\",\"t\":\"setup\"}"
import script from "./Participants.vue?vue&type=script&lang=js"
export * from "./Participants.vue?vue&type=script&lang=js"

import "./Participants.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script